import { render, staticRenderFns } from "./SportsComingSoon.vue?vue&type=template&id=c0015a5a&scoped=true"
import script from "./SportsComingSoon.vue?vue&type=script&lang=js"
export * from "./SportsComingSoon.vue?vue&type=script&lang=js"
import style0 from "./SportsComingSoon.vue?vue&type=style&index=0&id=c0015a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0015a5a",
  null
  
)

export default component.exports